import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import "../../style.css";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "../../../../User";
import { ProfileContext } from "../../../Profil";
import { dateFormat } from "../../../../../Services/Format/date";

function Pengabdian() {
  const userContext = useContext(UserContext);
  const profileContext = useContext(ProfileContext);
  const location = useLocation();

  return (
    <div className="pengabdian-box box-wrapper">
      <div className="box-header-area">
        <span className="box-title-text">Pengabdian</span>
        <div className="box-action-area">
          {/* <div className="single-button download-button">
            <span className="button-text-area">
              <span className="button-icon">
                <FontAwesomeIcon icon={faFilePdf} />
              </span>
              <span className="button-text">Download as PDF</span>
            </span>
          </div> */}
        </div>
      </div>
      <div className="box-body-area">
        <div className="box-body-top">
          <div className="inner-box-body-top-left">
            <div className="single-info total">
              <span className="info-label">Total :</span>
              <span className="info-value">
                {profileContext.pengabdian.length}
              </span>
            </div>
          </div>
          <div className="inner-box-body-top-right">
            {/* <div className="single-action pagination">
              <div className="prev-button-area">
                <div className="single-button prev-button">
                  <FontAwesomeIcon icon={faChevronLeft} />
                </div>
              </div>
              <div className="page-info-area">
                <span className="page-info">Page 1 of 2</span>
              </div>
              <div className="next-button-area">
                <div className="single-button next-button active">
                  <FontAwesomeIcon icon={faChevronRight} />
                </div>
              </div>
            </div> */}
          </div>
        </div>
        {/* <div className="row">
          <div className="single-box col-lg-4 col-md-6 col-12">
            <div className="inner-box">
              <div className="title-area">
                <span className="title-text">Give Back X</span>
              </div>
              <div className="type-area">
                <span className="type-value sirkumsisi">Sirkumsisi</span>
              </div>
              <div className="period-area">
                <span className="period-value">12-08-2020</span>
              </div>
              <div className="position-area">
                <div className="float-box-position">
                  <span className="position-value">Peserta</span>
                </div>
              </div>
              <div className="certificate-area">
                <span className="icon-area">
                  <FontAwesomeIcon icon={faFilePdf} />
                </span>
                <span className="text-area">Sertifikat</span>
              </div>
            </div>
          </div>
          <div className="single-box col-lg-4 col-md-6 col-12">
            <div className="inner-box">
              <div className="title-area">
                <span className="title-text">Give Back Y</span>
              </div>
              <div className="type-area">
                <span className="type-value tim-medis-fkui">
                  Tim Medis FKUI
                </span>
              </div>
              <div className="period-area">
                <span className="period-value">12-08-2020</span>
              </div>
              <div className="position-area">
                <div className="float-box-position">
                  <span className="position-value">Peserta</span>
                </div>
              </div>
              <div className="certificate-area">
                <span className="icon-area">
                  <FontAwesomeIcon icon={faFilePdf} />
                </span>
                <span className="text-area">Sertifikat</span>
              </div>
            </div>
          </div>
          <div className="single-box col-lg-4 col-md-6 col-12">
            <div className="inner-box">
              <div className="title-area">
                <span className="title-text">Give Back Z</span>
              </div>
              <div className="type-area">
                <span className="type-value pengobatan-massal">
                  Pengobatan Massal
                </span>
              </div>
              <div className="period-area">
                <span className="period-value">12-08-2020</span>
              </div>
              <div className="position-area">
                <div className="float-box-position">
                  <span className="position-value">Peserta</span>
                </div>
              </div>
              <div className="certificate-area">
                <span className="icon-area">
                  <FontAwesomeIcon icon={faFilePdf} />
                </span>
                <span className="text-area">Sertifikat</span>
              </div>
            </div>
          </div>
        </div> */}
        {profileContext.pengabdian.length > 0 && (
          <div className="table-wrapper">
            <table id="pengabdian-table">
              <thead>
                <tr>
                  <th>Nama Kegiatan</th>
                  <th>Waktu Kegiatan</th>
                  <th>Jumlah Keikutsertaan Masyarakat</th>
                  <th>Peran Dalam Kegiatan</th>
                  {location.pathname === "/profil" && <th>Sertifikat</th>}
                </tr>
              </thead>
              <tbody>
                {profileContext.pengabdian.map((item, index) => (
                  <tr key={index}>
                    <td>{item.nama_kegiatan}</td>
                    <td>
                      {dateFormat(
                        new Date(item.waktu_pelaksanaan),
                        "dd-MM-yyyy"
                      )}
                    </td>
                    <td>
                      {item.jumlah_masyarakat || item.jumlah_masyarakat === 0 
                        ? item.jumlah_masyarakat
                        : 0
                      }
                    </td>
                    <td>{item.peran ? item.peran : "Peserta"}</td>
                    {location.pathname === "/profil" && (
                      <td>
                        <div className="button-area">
                          <span className="icon-area">
                            <FontAwesomeIcon icon={faFilePdf} />
                          </span>
                          <span className="text-area">Download as PDF</span>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Pengabdian;
